/** @format */

import {Box, Typography} from '@mui/material';
import {styled} from '@mui/material/styles';

export const LabelText = styled(Typography)(({theme}) => ({
  fontSize: 12,
  color: theme.palette.semantic_dark?.surface.onSurfaceMuted,
  fontWeight: 400,
  position: 'absolute',
  right: theme.spacing(3.5),
}));

export const LabelFrom = styled(LabelText)(() => ({
  bottom: 0,
}));

export const LabelTo = styled(LabelText)(() => ({
  top: 0,
}));

export const WidgetTooltip = styled(Box)(() => ({
  position: 'absolute',
  top: 0,
  right: 0,
}));

export const MainContent = styled(Box)({
  display: 'flex',
  height: 140,
});

export const LeftCol = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'flex-end',
  minWidth: '85px',
  paddingRight: theme.spacing(2),
}));

export const CenterLineWrap = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
}));

export const VerticalLine = styled('div')<{
  gradient: string;
}>(({gradient}) => ({
  width: 6,
  borderRadius: 3,
  height: '100%',
  background: gradient,
}));

interface RightColProps {
  isNotAvailable?: boolean;
}

export const RightCol = styled(Box, {
  shouldForwardProp: prop => prop !== 'isNotAvailable',
})<RightColProps>(({isNotAvailable, theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: isNotAvailable ? 'center' : 'space-between',
  alignItems: 'flex-start',
  paddingLeft: theme.spacing(2),
}));

export const TopText = styled(Typography)(({theme}) => ({
  fontSize: 12,
  color: theme.palette.semantic_dark?.surface.onSurface,
  fontWeight: 400,
}));

export const PredictionRow = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
}));

export const PredictionValue = styled(Typography)(({theme}) => ({
  fontSize: 16,
  color: theme.palette.semantic_dark?.surface.onSurface,
  fontWeight: 500,
  lineHeight: 1,
}));

export const Currency = styled(Typography)(({theme}) => ({
  fontSize: '14px',
  color: theme.palette.semantic_dark?.surface.onSurfaceMuted,
  fontWeight: 400,
  marginLeft: theme.spacing(1),
}));

export const NotAvailableText = styled(Typography)(({theme}) => ({
  fontSize: 14,
  color: theme.palette.semantic_dark?.surface.onSurfaceMuted,
  textAlign: 'center',
  width: '100%',
}));

export const Dot = styled(Box)(({theme}) => ({
  width: '2px',
  height: '2px',
  borderRadius: '1px',
  background: theme.palette.semantic_dark?.surface.onSurfaceMuted,
  flexShrink: 0,
}));

export const DotBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
}));
